import { css } from "lit";

export const styles = css`
  :host {
    display: inline-flex;
  }

  .event-badge {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-300);

    background-color: color-mix(in srgb, var(--sds-color-gray-800) 60%, transparent);
    backdrop-filter: blur(10px);
    color: var(--sds-color-gray-100);
    border-radius: var(--sds-size-radius-400);
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-01) var(--sds-typography-family-title);

    /* We have this line height in the design, but visually it looks a bit different */
    /* line-height: 20px; */
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--sds-color-gray-100);
    flex-shrink: 0;
  }

  .event-badge.live .dot,
  .event-badge.lobby .dot {
    background: var(--sds-color-background-danger-default);
  }

  .event-badge.ended .dot {
    background: black;
  }
`;
